import { decimal } from '@/js/shared/billables/decimal';

function createAmountFormatter(useGrouping) {
  return new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
    useGrouping,
  });
}

const groupedAmountFormatter = createAmountFormatter(true);
const ungroupedAmountFormatter = createAmountFormatter(false);

export function formatCurrency(value, { symbol, side }, { useGrouping = true } = {}) {
  const formatter = useGrouping ? groupedAmountFormatter : ungroupedAmountFormatter;
  // Pass a string so Intl does not lose the arbitrary precision provided by big.js.
  const amount = formatter.format(decimal(value).toFixed(2));

  return side === 'left' ? `${symbol}${amount}` : `${amount} ${symbol}`;
}
